import type { ReactNode } from 'react';

export const symbol_detector_offline: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m480-224-83 83q-9 9-21 9t-21-9q-9-9-9-21t9-21l83-83-83-83q-9-9-9-21t9-21q9-9 21-9t21 9l83 83 83-83q9-9 21-9t21 9q9 9 9 21t-9 21l-83 83 83 83q9 9 9 21t-9 21q-9 9-21 9t-21-9l-83-83ZM180-780v60h600v-60H180Zm121 120 18 60h322l18-60H301Zm18 120q-20 0-35.5-11.5T262-582l-25-78h-57q-25 0-42.5-17.5T120-720v-60q0-25 17.5-42.5T180-840h600q25 0 42.5 17.5T840-780v60q0 25-17.5 42.5T780-660h-57l-30 81q-7 17-22.5 28T636-540H319ZM180-780v60-60Z"
		/>
	</svg>
);
